/* eslint-disable no-unused-expressions */
import React, { useState } from 'react';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import { Draw, Visibility, VisibilityOff, Close } from '@mui/icons-material';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    InputAdornment,
    TextField,
    Typography
} from '@mui/material';
import { LoadingButton } from '@mui/lab';

function ESign({ renderButton, onChange, isIcon = true, onClickOpen = null, onClickClose = null }) {
    const [open, setOpen] = useState(false);

    const formik = useFormik({
        initialValues: {
            password: '',
            showPassword: false
        }
    });

    const handleDialogOpen = () => {
        setOpen(true);
        if (onClickOpen) {
            onClickOpen();
        }
    };

    const handleDialogClose = () => {
        setOpen(false);
        formik.resetForm();
        if (onClickClose) {
            onClickClose();
        }
    };

    const handleSubmit = () => {
        if (onChange) {
            onChange(formik.values.password);
        }
        handleDialogClose();
    };

    return (
        <>
            {renderButton ? (
                renderButton({
                    onClick: handleDialogOpen
                })
            ) : (
                <Button variant="contained" size="small" onClick={handleDialogOpen}>
                    {isIcon && <Draw sx={{ height: 24, width: 24, mr: 1 }} />}E-Sign
                </Button>
            )}
            <Dialog open={open} onClose={handleDialogClose} fullWidth maxWidth="xs">
                <IconButton
                    onClick={() => {
                        formik.resetForm();
                        handleDialogClose();
                    }}
                    sx={{ position: 'absolute', top: 0, right: 0, m: 1 }}
                >
                    <Close />
                </IconButton>
                <DialogTitle>E-Sign</DialogTitle>
                <DialogContent
                    sx={{
                        p: 2
                    }}
                >
                    <TextField
                        sx={{ mt: 2 }}
                        label="Password"
                        type="password"
                        fullWidth
                        variant="outlined"
                        autoComplete="off"
                        {...formik.getFieldProps('password')}
                        error={formik.touched.password && Boolean(formik.errors.password)}
                        helperText={formik.touched.password && formik.errors.password}
                    />
                </DialogContent>
                <DialogActions>
                    <LoadingButton loading={false} variant="contained" onClick={handleSubmit}>
                        Sign
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    );
}

ESign.propTypes = {
    onChange: PropTypes.func
};

export default ESign;
